import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { IErrorResponse, QueryKeys } from "../../querys/querys.enum";
import axiosInstance from "../../../utils/axios";
import { NotificationTypesResponse } from "../../../models/Interface/NotificationManagement.interface";

/**
 * GET /notifications-management/types — permission: `get:notification:types`
 *
 * Option source for every notification-type select on the screen. Each type
 * appears once however many key sets it owns, so variant options must come
 * from the keys-values endpoint instead. Cached for the page visit.
 */
const useNotificationTypes = () => {
  return useQuery<NotificationTypesResponse, AxiosError<IErrorResponse>>({
    queryKey: [QueryKeys.NOTIFICATION_TYPES],
    queryFn: async () => {
      return (await axiosInstance.get(`/notifications-management/types`)).data;
    },
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    retry: 0,
  });
};

export default useNotificationTypes;
